module.exports = __webpack_public_path__ + "img/495CA6_CCD2E6_A5B1D8_1E2852-256px.b8473c5c.png";